import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { classNames } from "../../../../../general/functions/propsComponent";
import { PencilSquare } from "react-bootstrap-icons";
import TextAreaQuill from "../../../../../general/components/Textarea/Quilljs/TextAreaQuill";

const exampleAsswer = `<h2>What is Lorem Ipsum?</h2><p class="ql-align-justify"><strong>Lorem Ipsum</strong>&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. </p><p><br></p>`;
export default function ModalTViewAnswer(props) {
  const { text, name, email, showModal, setShowModal } = props;

  return (
    <>
      {showModal ? (
        <>
          <div className="backdrop-filter backdrop-blur-sm  flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
            <div className="relative  my-6 mx-auto w-11/12  ">
              {/*content*/}
              <div className="border-t-8  rounded-md border-gray-100 shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none ">
                {/*header*/}
                <button
                  className="absolute top-0 right-4 p-1 ml-auto bg-transparent border-0 text-black opacity-4 float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                  onClick={() => setShowModal(false)}
                >
                  <span className="bg-transparent text-gray-800 opacity-75 h-6 w-6 text-2xl block outline-none focus:outline-none">
                    ×
                  </span>
                </button>
                <div className="flex items-start flex-col pt-6 px-7 pb-0 ">
                  <h3 className="text-3xl font-semibold  text-slate-800 ">
                    {name}
                  </h3>
                  <small>{email}</small>
                </div>

                {/*body*/}
                <h1 className=" px-7  w-full text-left text-sm font-bold text-gray-600">
                  Answer
                  <hr />
                </h1>
                <div className="relative px-4 py-4  flex-auto ql-container ql-snow ">
                  <div
                    className="ql-editor "
                    style={{ maxHeight: "63vh", height: "63vh" }}
                  >
                    <div dangerouslySetInnerHTML={{ __html: text }} />
                  </div>
                </div>
                {/*footer*/}
                <div className="flex items-center justify-end p-6 rounded-b gap-1">
                  <button
                    className="btn-secondary"
                    type="button"
                    onClick={() => setShowModal(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
        </>
      ) : null}
    </>
  );
}
